const good_atmosphere = `Hyvä työilmapiiri on tärkeää, jotta olosi on onnellinen ja mukava työssä.
Se tarkoittaa, että tunnet olosi turvalliseksi ja arvostetuksi tehdessäsi työtäsi.
Kun ihmiset tulevat hyvin toimeen ja auttavat toisiaan, se voi tehdä työstä helpompaa ja nautinnollisempaa.
On mukavaa, että pomo ja työtoverit ovat ystävällisiä ja kannustavia ja jotka kuuntelevat ajatuksiasi.
Kun työilmapiiri on hyvä, se voi auttaa ihmisiä tekemään työnsä paremmin.
He saattavat tuntea olevansa motivoituneempia ja haluavat tehdä parhaansa.
Se voi myös saada heidät tuntemaan olevansa enemmän yhteydessä työhönsä ja ihmisiin, joiden kanssa he työskentelevät.
Tämä voi tehdä koko joukkueesta vahvemman ja menestyvämmän.
Jos työilmapiiri ei kuitenkaan ole hyvä, se voi saada ihmiset tuntemaan olonsa onnettomaksi ja stressaantuneeksi.
He eivät ehkä halua mennä töihin eivätkä ehkä tee parhaansa.
On tärkeää, että pomot ovat ymmärtäväisiä ja että kaikki kohtelevat toisiaan kunnioittavasti.
Kun ihmiset tuntevat olonsa mukavaksi ja arvostetuiksi työssään, he voivat pärjätä paremmin ja tuntea olonsa onnellisemmaksi työssään.`;

export default good_atmosphere;